import CountyReports from "@/components/CountyReports";
import Metrics from "@/components/Metrics";
import { Stack, Tabs, Title } from "@mantine/core";
import { IconDashboardFilled, IconTools } from "@tabler/icons-react";
import { useEffect } from "react";

const CountyAdminPage = () => {
    useEffect(() => {
        document.title = "County Admin Dashboard - Guard Dog Real Estate Protection Service";
    }, [])
    return (
        <Stack>
            <Title order={1} c='pq-red' style={{ fontFamily: 'Elston, sans-serif', letterSpacing: '2px' }}>County Admin</Title>
            <Tabs defaultValue="metrics" style={{width: '100%'}}>
                <Tabs.List>
                    <Tabs.Tab value="metrics" leftSection={<IconDashboardFilled size={14} />}>Electronic Notifications</Tabs.Tab>
                    <Tabs.Tab value="reports" leftSection={<IconTools size={14} />}>Printed Notifications</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel m='md' value="metrics">
                    <Metrics />
                </Tabs.Panel>
                <Tabs.Panel  m='md' value="reports">
                    <CountyReports />
                </Tabs.Panel>
            </Tabs>
        </Stack>
    )
}
export default CountyAdminPage;